import styled from "styled-components";
import { FLEX } from "styles/flex";
import * as mediaQuery from "components/MediaQuery";
import { COLORS } from "styles/colors";
import { useAppSelector } from "redux/hooks";
import { useLocation } from "react-router-dom";
import { useMemo } from "react";
import { calcRem } from "styles/theme";
import { BsChevronRight } from "react-icons/bs";
import { useMenu } from "hook/useMenu";
import {
  ProfileAccountInfo,
} from "api/interfaces/accountInterface.interface";
import { LEVEL_TYPE } from "api/interfaces/commonInterface.interface";
import useAccountAccess from "hook/useAccountAccess";

// 경로 이동 props
export interface RoutesProps {
  name: string;
  routeName?: string;
  accountId?: string;
}
type Props = {};
function RoutesMark(props: Props): JSX.Element {
  const location = useLocation();
  const selectedAccount: ProfileAccountInfo = useAppSelector(
    (state) => state.accountSettings
  );

  const { menuNavigation } = useMenu({});

  const getPath = (accountLevel?: LEVEL_TYPE) => {
    if (accountLevel === LEVEL_TYPE.EU) {
      return "/recorders/list";
    }
    if (location.pathname.includes("subscription")) {
      return "/subscription/organization";
    }
    return "/account";
  };

  const breadcrumb = useMemo(() => {
    return [...(selectedAccount.parentAccount || [])].reverse();
  }, [selectedAccount.parentAccount]);

  if (
    location.pathname.includes("account") ||
    location.pathname.includes("/recorders") ||
    (location.pathname.includes("subscription") &&
      !location.pathname.includes("subscription/organization/history") &&
      !location.pathname.includes("subscription/keys/organization/history") &&
      !location.pathname.includes("subscription/lyve"))
  ) {
    return (
      <RoutesContainer>
        {breadcrumb.map((link, index) => (
          <RouteItemButton
            key={index}
            accountId={link.accountId}
            accountName={link.accountName}
            toPath={getPath()}
            index={index}
          />
        ))}
        <RoutesItem>
          <button
            onClick={() =>
              menuNavigation({ to: getPath(selectedAccount.accountLevel) })
            }
            data-testid="blocks-headernav-sub-button-menu-navigation"
          >
            {selectedAccount.accountName}
          </button>
        </RoutesItem>
      </RoutesContainer>
    );
  }
  return <div style={{ height: 20 }} className="routes-mark-trick" />;
}

const RouteItemButton = ({
  accountId,
  accountName,
  toPath,
  index,
}: {
  accountId: string;
  accountName: string;
  toPath: string;
  index: number;
}) => {
  const { AccountAccessButton, AccountAccessModal } = useAccountAccess({
    buttonType: accountName,
    useTemporary: false,
    isShowOnlyUser: true,
    toPath,
  });
  return (
    <>
      <RoutesItem data-url={toPath}>
        <AccountAccessButton accountId={accountId} index={index} />
        <span className="chevron-right">
          <BsChevronRight size={10} />
        </span>
      </RoutesItem>
      {AccountAccessModal}
    </>
  );
};

const RoutesContainer = styled.ul`
  gap: 7px;
  height: 20px;
  ${mediaQuery.isDefault} {
    ${FLEX.FlexStartCenter};
  }
  ${mediaQuery.isMobile} {
    ${FLEX.FlexCenterCenter};
    background-color: ${COLORS.PRIMARY3};
    border-bottom: 1px solid ${COLORS.BUTTONS1};
    padding: 5px;
  }
`;

const RoutesItem = styled.li`
  ${FLEX.FlexAroundCenter};
  gap: 4px;
  ${mediaQuery.isDefault} {
    color: ${(props) => props.theme.COLORS.STATUS};

    > button {
      color: ${(props) => props.theme.COLORS.STATUS};
      font-size: ${calcRem(14)};

      &:hover {
        text-decoration: underline;
      }
    }

    * {
      color: ${(props) => props.theme.COLORS.STATUS};
    }
  }

  ${mediaQuery.isMobile} {
    color: ${(props) => props.theme.COLORS.STATUS};
    * {
      color: ${(props) => props.theme.COLORS.STATUS};
    }
  }
`;

export default RoutesMark;
